import { createEvent, createStore } from 'effector'

export const actions = {
  setServices: createEvent<SocieteResponse[]>('setServices'),
  resetServices: createEvent('resetServices'),
  setTechnicians: createEvent<UserResponse[]>('setTechnicians'),
  resetTechnicians: createEvent('resetTechnicians'),
  reset: createEvent('reset'),
}

const initialState: SocieteState = {
  services: [],
  technicians: [],
}

export const store = createStore<SocieteState>(initialState, { name: 'societe' })
  .on(actions.setServices, (s, services) => ({ ...s, services }))
  .on(actions.resetServices, (s) => ({ ...s, services: initialState.services }))
  .on(actions.setTechnicians, (s, technicians) => ({ ...s, technicians }))
  .on(actions.resetTechnicians, (s) => ({ ...s, technicians: initialState.technicians }))
  .reset(actions.reset)
